
export const MANAGE_RULE = "Manage Rule"
export const SAVE = "Save"
export const ENABLE_MATCH_RULE = "Enable Match Rule"
export const RULE_DESCRIPTION = "Enabling this rule allows customers to match again only after time limit"